import { defineComponent } from "vue";
import { SettingsItem, Settings } from "@live/settings/Settings";
export default defineComponent({
    data: function () {
        return {
            boxSelected: []
        };
    },
    setup: function () {
        const FLIGHT_ROUTE = SettingsItem.FLIGHT_ROUTE;
        const AUTOMATIC_REFRESH = SettingsItem.AUTOMATIC_REFRESH;
        const DISPLAY_ACTIVE_AIRPORTS = SettingsItem.DISPLAY_ACTIVE_AIRPORTS;
        const setSettingTrueIfNull = (settingsItem) => {
            const value = Settings.get(settingsItem);
            if (value == null) {
                Settings.set(settingsItem, true);
            }
        };
        setSettingTrueIfNull(FLIGHT_ROUTE);
        setSettingTrueIfNull(AUTOMATIC_REFRESH);
        setSettingTrueIfNull(DISPLAY_ACTIVE_AIRPORTS);
        return {
            FLIGHT_ROUTE,
            AUTOMATIC_REFRESH,
            DISPLAY_ACTIVE_AIRPORTS
        };
    },
    watch: {
        boxSelected: function (activeSettings) {
            const setSettings = (settingsItem) => {
                Settings.set(settingsItem, activeSettings.includes(settingsItem));
            };
            setSettings(SettingsItem.FLIGHT_ROUTE);
            setSettings(SettingsItem.AUTOMATIC_REFRESH);
            setSettings(SettingsItem.DISPLAY_ACTIVE_AIRPORTS);
        }
    },
    mounted: function () {
        const flightRoute = Settings.get(SettingsItem.FLIGHT_ROUTE) == "true";
        const autoRefresh = Settings.get(SettingsItem.AUTOMATIC_REFRESH) == "true";
        const displayActiveAirports = Settings.get(SettingsItem.DISPLAY_ACTIVE_AIRPORTS) == "true";
        const pushSelectIfTrue = (settingsItem, b) => {
            if (b) {
                this.boxSelected.push(settingsItem);
            }
        };
        pushSelectIfTrue(SettingsItem.FLIGHT_ROUTE, flightRoute);
        pushSelectIfTrue(SettingsItem.AUTOMATIC_REFRESH, autoRefresh);
        pushSelectIfTrue(SettingsItem.DISPLAY_ACTIVE_AIRPORTS, displayActiveAirports);
    }
});
